import { useState } from 'react'

import { UserProfilePopover } from './UserProfilePopover/UserProfilePopover'

const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false)

  return <UserProfilePopover isOpen={isOpen} setIsOpen={setIsOpen} />
}

export { UserProfile }
